module.exports = __webpack_public_path__ + "img/right_md_4.44a916f7.jpg";